/** Matches the Studies page-title shape: "Section · Study · Askable". */
export const getFocusGroupPageTitle = ({ section, study }: { section: string; study: string }): string =>
  `${section} · ${study} · Askable`;
